module.exports = {
  development: false,
  app: 'azxbet',
  apps: {
    dev: {
      common: {
        scheme: 'http',
        points: [ 1, 2 ],
        locales: [ 'en', 'ru', 'az' ],
        locale: 'en',
        mailer: {
          user: 'idmanbet@gmail.com',
          pass: '123@zXc@123'
        },
        emails: {
          noreply: 'noreply@idmanbet.com'
        },
        actions: {
          deposit: 'deposit',
          withdrawal: 'withdrawal'
        }
      },
      main: {
        host: 'site.betspectrum.com',
        port: 4444,
        point: 1
      },
      mobile: {
        host: 'm.betspectrum.com',
        port: 444,
        point: 2
      }
    },
    azxbet: {
      common: {
        scheme: 'https',
        points: [ 5, 6 ],
        locales: [ 'en', 'ru', 'az' ],
        locale: 'ru',
        mailer: {
          user: 'support@bayerbet.net',
          pass: '1239982_Bayerbet'
        },
        emails: {
          noreply: 'support@bayerbet.net',
          rustem: 'support@bayerbet.net'
        },
        actions: {
          deposit: 'deposit',
          withdrawal: 'withdrawal',
          depositAzx: 'depositAzx'
        }
      },
      main: {
        host: 's.sportdemo.ru',
        port: 12000,
        point: 5
      },
      mobile: {
        host: 'm.sportdemo.ru',
        port: 12001,
        point: 6
      }
    }
  },
  clientSuite: [ 'name', 'scheme', 'host', 'port', 'locales', 'locale' ],
  methods: {
    server: {
      whiteList: function () {
        const url = this.scheme + '://' + this.host
        return [ url, url + ':88' ]
      }
    },
    client: {
      axiosBaseUrl: function () {
        return this.scheme + '://' + this.host + ':' + this.port
      }
    }
  },
  application: function (mobile = false) {
    return this.server(mobile)
  },
  server: function (mobile = false) {
    const mdl = mobile ? 'mobile' : 'main'
    const app = this.apps[this.app]
    let server = Object.assign({}, app.common, app[mdl], this.methods.server)
    server.development = this.development
    server.name = this.app
    if (this.development) {
      server = Object.assign(server, {
        scheme: this.apps.dev.common.scheme,
        host: this.apps.dev[mdl].host,
        port: this.apps.dev[mdl].port
      })
    }
    return server
  },
  client: function (mobile = false) {
    const server = this.server(mobile)
    let client = []
    for (let i in this.clientSuite) {
      client[this.clientSuite[i]] = server[this.clientSuite[i]]
    }
    return Object.assign(client, this.methods.client)
  }
}



//////////////////
// WEBPACK FOOTER
// ../server/src/config/application.js
// module id = MoJj
// module chunks = 2